import axios from "../../axios";

export const searchFootballEntities = async ({
  limit,
  offset,
  search,
}: {
  limit?: number;
  offset?: number;
  search?: string;
}) => {
  const params = new URLSearchParams();
  if (limit) params.append("limit", limit.toString());
  if (offset) params.append("offset", offset.toString());
  // if (search) params.append("search", search);
  const { data } = await axios.get(`/search/football-entities?${params.toString()}`);
  return data;
};
